import { useContext } from 'react';

import { DebtConContext } from '@App/contexts/DebtCon';
import EligibilityLayout from '@src/ui/layouts/EligibilityLayout';
import DebtInputView from '@src/ui/views/debtCon/DebtInput/DebtInputView';

const DebtInput = () => {
    const { loading } = useContext(DebtConContext);

    return (
        <EligibilityLayout loading={loading} debtInputPage>
            <DebtInputView />
        </EligibilityLayout>
    );
};

export default DebtInput;
